var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{style:(_vm.domStyle),attrs:{"id":"topTop"}},[_c('object',{ref:"svgTemplate",staticClass:"emb",attrs:{"data":_vm.pictureUrl,"type":"image/svg+xml"}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f3c1f08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/primitives/fvBadge/fvSvgDemo.vue
// module id = null
// module chunks = 